export enum VoiceCallAgentType {
  VYSE = 'vyse',
}

export interface VoiceCallAgentConfiguration {
  configType: VoiceCallAgentType;
}
